import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/_services/config.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  authenticationService: AuthenticationService;
  settingCollapsed = false;
  assetCollapsed = false;
  reportCollapsed = false;
  report2Collapsed = false;
  assessCollapsed = false;
  generalCollapsed = false;
  
  _version="";

  constructor(
    authenticationService: AuthenticationService,
    private configService: ConfigService
    ) {
    this.authenticationService = authenticationService;  }

  ngOnInit() {
    const body = document.querySelector('body');

    document.querySelectorAll('.sidebar .nav-item').forEach(function (el) {
      el.addEventListener('mouseover', function() {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function() {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });

    this._version = this.configService.config.version;

  }

  logout() {
    this.authenticationService.logout();
  }

}
